import CWFlogo from "assets/cwflogo.jpeg";

export const NavItems = [
  {
    id: "0",
    route: "",
    name: "Welcome",
    role: "Select a Role",
    primarycolor: "#000C1D",
    secondarycolor: "#000C1D",
    emoji: "🚀",
    header: "Choose your Location and Role to get started.",
    title: "Build a Better Future. Make an Impact.",
    description:
      "Join an ecosystem or create your own with smart resources, tools, content & networks.  ",
    // link: "/news",

    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a .",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },

  // {
  //   id: "1",
  //   route: "organizations",
  //   name: "organizations",
  //   role: "Organization",
  //   // primarycolor: "#003399",
  //   // secondarycolor: "#003399",
  //   // primarycolor: "#E53935",
  //   // secondarycolor: "#B71C1C",
  //   primarycolor: "red",
  //   secondarycolor: "#FF0000",
  //   emoji: "🏗️",
  //   title: "Scale your impact.",
  //   header: "For Organizations Supporting Stakeholders.",
  //   description:
  //     "Gain access to smart management resources, advanced tools, content & networks.  ",
  //   link: "/news",
  //   submitCopy: "Pre-Registration Open",
  //   // backgroundImage:
  //   //   // "https://images.unsplash.com/photo-1600320844678-43cebba1cdfe?q=80&w=3200&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //   //   "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     backgroundVideo: "https://media.istockphoto.com/id/1083275118/video/4k-uhd-time-lapse-of-crowded-people-at-exhibition-hall-entrance-international-tradeshow-expo.mp4?s=mp4-640x640-is&k=20&c=sk66hVRh8pFgQjPz2TcWgGuq3_zAImKtiX5edd27WIQ=",
  //   section2: {
  //     title: "Welcome!",
  //     description:
  //       "Join an ecosystem or create your with smart resources, tools, content & networks.",
  //     submitCopy: "Pre-Registration Open",
  //     backgroundImage:
  //       "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //     bullet1: "Select a a role to get started.",
  //     bullet2: "Each Role has a unique purpose.",
  //     bullet3: "Registration is Free.  ",
  //     link: "link",
  //   },
  // },
  {
    id: "2",
    route: "community",
    name: "community",
    role: "Community",
    primarycolor: "#3E2EA3",
    secondarycolor: "#2E2280",
    emoji: "🏛️ ",
    header: "Support Local Economic Development.",
    title: "Crucial Front Line Support.",
    description:
      "Support your stakeholders with access to smart resources, programs, & networks. ",
    // link: "/news/thrive-lab-x-canada-innovates",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1494587416117-f102a2ac0a8d?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      // backgroundVideo: "https://media.istockphoto.com/id/1371228411/video/time-lapse-of-kabukicho-night-time-with-crowd-people-walking-on-the-street-in-shinjuku-tokyo.mp4?s=mp4-640x640-is&k=20&c=j9R_eWXlD4hdNYMMWmRzGdJSHk2g38u0oV6lDPXFEYY=",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1:
        "You're a local community organizaiton, economic hub, or municipality office.",
      bullet2:
        "You would like to moderate, organize or contribute to local ecosystems.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },
  {
    id: "3",
    route: "founders",
    name: "Founders",
    role: "Founder",
    // primarycolor: "black",
    // secondarycolor: "#000000",
    primarycolor: "#18303F",
    secondarycolor: "#18303F",
    emoji: "👩🏾‍💻",
    header: "We empower Founder, Startup, & Non–Profit Success.",
    title: "Build a Roadmap & Hit Your Metrics.",
    description:
      "Access smart frameworks, tools, programs & networks across an ecosystem of stakeholders.  ",
    // link: "/news",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2338&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    // backgroundVideo: "https://media.istockphoto.com/id/2164246260/video/human-fingers-work.mp4?s=mp4-640x640-is&k=20&c=HUYJlR3tM3sRZAZhk5Uu739O8sTtcDZsai8w3h-PVno=",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },
  {
    id: "4",
    route: "ecosystems",
    name: "ecosystems",
    role: "Ecosystem",
    primarycolor: "#CF138F",
    secondarycolor: "#A31172",
    emoji: "🚀",
    header: "Built for Innovation Ecosystems & Hubs.",
    title: "Drive Innovation at Scale.",
    description:
      "For ecosystems, hubs, organizations and advisors. Amplify your impact at scale. ",
    // link: "/news",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      // backgroundVideo: "https://media.istockphoto.com/id/1083275118/video/4k-uhd-time-lapse-of-crowded-people-at-exhibition-hall-entrance-international-tradeshow-expo.mp4?s=mp4-640x640-is&k=20&c=sk66hVRh8pFgQjPz2TcWgGuq3_zAImKtiX5edd27WIQ=",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your own with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },
  {
    id: "5",
    route: "service-providers",
    name: "service providers",
    role: "Service Provider",
    header: "Register as a Service Provider.",
    title: "Supercharge Ecosystems",
    primarycolor: "#FFCC00",
    secondarycolor: "#E6B800",
    emoji: "⚡",
    description:
      "Access tools, resources, and networks to deploy your offerings across ecosystems.  ",
    // link: "/news",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://plus.unsplash.com/premium_photo-1683121874142-1de003f138a8?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    // backgroundVideo: "https://media.istockphoto.com/id/1135442692/video/business-person-meeting-and-working-with-statistics.mp4?s=mp4-640x640-is&k=20&c=pv1yeBbWUcOqHDZzcjEHK0zYo0dRoUKth1Z3epB1F-M=",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },
];

export const Orgs = [
  {
    id: "2",
    route: "canadianwomensfoundation",
    name: "Women Founders",
    role: "",
    primarycolor: "#28A745",
    secondarycolor: "#1E7B34",
    emoji: "🚀",
    header: "Investment Preparedness for Women Founders",
    image:
      "data:image/png;base64,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",
    title: "Capacity Building for Investment Preparedness",
    description:
      "Equip yourself with smart resources, tools, content, & networks via this Canadian Women's Foundation program. ",
    link: "/news/canadian-womens-foundation",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1531058240690-006c446962d8?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
  },
  {
    id: "3",
    route: "thrivelab",
    name: "Thrive Lab for Women Partner",
    role: "",
    primarycolor: "#18303F",
    secondarycolor: "#18303F",
    emoji: "🚀",
    header: "Thrive Lab for Women Offical Partner",
    image: "https://www.bdc.ca/assets/icons/bdc_logo.svg",
    title: "Apply for nomination",
    description:
      "Apply to be nominated via Canada Innovates to the BDC Thrive Lab investment program.  ",
    link: "/news/thrive-lab-x-canada-innovates",
    submitCopy: "Pre-Registration Open",
    backgroundImage:
      "https://images.unsplash.com/photo-1573496773322-2567977fde08?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
    section3: {
      title: "Welcome to Canada Innovates!",
      description:
        "Join or create your own ecosystem of resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  },
  {
    id: "4",
    route: "parkdale",
    name: "Welcome",
    role: "",
    primarycolor: "#f4b600",
    secondarycolor: "#ecb104",
    emoji: "👩🏾",
    header: "Join Parkdale's online Innovation Community.",
    // image:
    // "https://www.parkdaleinnovates.org/images/rings.png",
    title: "Welcome to Parkdale Centre for Innovation!",
    description:
      "Get started with profile registration. Visit our website to ",
    link: "https://parkdaleinnovates.org",
    submitCopy: "Get Started",
    backgroundImage:
      "https://www.parkdaleinnovates.org/images/backgrounds/centreside.png",

    section2: {
      title: "Welcome!",
      description:
        "Join an ecosystem or create your with smart resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      bullet1: "Select a a role to get started.",
      bullet2: "Each Role has a unique purpose.",
      bullet3: "Registration is Free.  ",
      link: "link",
    },
    section3: {
      title: "Welcome to Canada Innovates!",
      description:
        "Join or create your own ecosystem of resources, tools, content & networks.",
      submitCopy: "Pre-Registration Open",
      backgroundImage:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  },
];
